import { BadgeCheck, FileText, Grid, User, Home, Map, Briefcase } from "lucide-react";


export const USER_DETAIL_TABS = [
    { key: "overview", title: "Overview", startIcon: <Grid size={16} /> },
    { key: "profile", title: "Profile", startIcon: <User size={16} /> },
    { key: "posts", title: "Posts", startIcon: <FileText  size={16} /> },
    { key: "subscriptions", title: "Subscriptions", startIcon: <User size={16} /> },
    { key: "verifications", title: "Verifications", startIcon: <BadgeCheck size={16} /> },
    { key: "public-properties", title: "Public Properties", startIcon: <Home size={16} /> },
    { key: "public-lands", title: "Public Lands", startIcon: <Map size={16} /> },
    { key: "broker-crm", title: "Broker CRM", startIcon: <Briefcase size={16} /> },
];

export const USER_DETAIL_PROFILE_TABS = [
    { key: "basic-info", title: "Basic Information" },
    { key: "experience", title: "Experience" },
    { key: "contact-purposes", title: "Contact Purposes" },
    { key: "work-regions", title: "Work Regions" },
    { key: "education", title: "Education" },
    { key: "products", title: "Products" },
    { key: "awards", title: "Awards" },
    { key: "certifications", title: "Certifications" },
    { key: "testimonials", title: "Testimonials" },
    { key: "companies", title: "Companies" },
    { key: "marketplace-listings", title: "Marketplace Listings" },
    { key: "requirements", title: "Requirements" }
];

export const USER_DETAIL_BROKER_CRM_TABS = [
    { key: "dashboard", title: "Dashboard" },
    { key: "clients", title: "Clients" },
    { key: "properties", title: "Properties" },
    { key: "lands", title: "Lands" },
    // { key: "leads", title: "Leads" },
    // { key: "followups", title: "Follow-ups" },
];